// @ts-nocheck
import { useCallback, useEffect, useState } from "react";
import chatService from "./service/chatService";
import { IReqRegisterChannelPerm } from "services/typings";
import Cookies from "js-cookie";
import { getAccessTokenByCustomerId } from "pages/Auth/utils";
import useSWR, { SWRConfiguration, mutate } from "swr";
import { useCurrentUser } from "components/CurrentUser/hooks";
import { useAuthorize, useIsAdmin } from "components/CurrentUser/hooks";
import { Resource, Permission } from "components/CurrentUser/constants";
import RestAPIClient from "services/RestAPIClient";
import { isMicroApp } from "utils/microApp";

const team_id = "07";
const biz_id = "07:22";

export const useRegisterChannelPerm = () => {
  const [loading, setLoading] = useState(false);

  const registerChannel = useCallback(
    async (req: IReqRegisterChannelPerm): Promise<any> => {
      try {
        setLoading(true);
        const res = await chatService.registerChannelPerm(req);
        return res;
      } catch (e) {
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  return [registerChannel, loading] as const;
};

export const useGetChannelPerm = () => {
  const customerId = Cookies.get("customer_id") || "";
  const { data, error } = useSWR(
    [customerId, biz_id],
    () =>
      chatService.getChannelPerm({
        receiver_id: biz_id,
        sender_id: customerId,
      }),
    {
      refreshInterval: 0,
      refreshWhenHidden: false,
      refreshWhenOffline: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      errorRetryCount: 0,
      errorRetryInterval: 0,
    }
  );
  const loading = !data && !error;
  return [data, loading, error];
};

export const useDestroyChat = () => {
  const destroy = () => {
    if (window.TIKI_CHAT_SDK) {
      // console.log("6");
      // @ts-ignore: Unreachable code error
      window.TIKI_CHAT_SDK.destroy();
    }
  };

  return { destroy };
};

export const useChat = () => {
  const customerId = Cookies.get("customer_id") || "";
  const [user] = useCurrentUser();

  const hasChatPermission = useAuthorize([
    [Resource.CHAT_AGENT, Permission.FULL_VIEW],
  ]);

  // const [channelPerm, loading, error] = useGetChannelPerm();
  // const [registerChannel] = useRegisterChannelPerm();
  // @ts-ignore: Unreachable code error

  const chatWithNewChannel = useCallback(() => {
    // console.log("5");
    if (hasChatPermission) return;
    const options = {
      sender_id: customerId,
      receiver_id: biz_id,
    };

    // @ts-ignore: Unreachable code error
    if (window.TIKI_CHAT_SDK) {
      // console.log("6");
      // @ts-ignore: Unreachable code error
      window.TIKI_CHAT_SDK.goToChannel(options);
    }
  }, [customerId, hasChatPermission]);

  const initChat = useCallback(async () => {
    const accessToken = await RestAPIClient.getToken();
    const options = {
      access_token: accessToken,
      refresh_token: "#",
      biz_id: hasChatPermission ? biz_id : "null",
      team_ids: hasChatPermission ? [team_id] : ["00"],
      // attention: true,
      lazyload: true,
      selector: "#tiki-chat",
    };

    if (window.TIKI_CHAT_SDK) {
      window.TIKI_CHAT_SDK.init(options);
    } else {
      var script = document.createElement("script");
      script.src = process.env.REACT_APP_SDK_CHAT;
      document.head.appendChild(script);
      script.onload = function () {
        TIKI_CHAT_SDK?.init(options);
      };
    }
    return true;
  }, [hasChatPermission]);

  useEffect(() => {
    if ((user?.type === "KOL" || hasChatPermission) && !isMicroApp) {
      console.log("hia");
      initChat().then((s) => {
        console.log("Chat Loaded");
      });
    }
  }, [hasChatPermission, initChat, user]);

  return { chatWithNewChannel };
};
